module.exports = __webpack_public_path__ + "static/img/2.ea6fb91.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/zh/2.png
// module id = Y7JG
// module chunks = 0